import { render, staticRenderFns } from "./RewardConsumption.vue?vue&type=template&id=aad408dc&"
import script from "./RewardConsumption.vue?vue&type=script&lang=js&"
export * from "./RewardConsumption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports